import './SnackBar.scss';

const SnackBar = (props: $TSFixMe) => {
  const { horizontal, vertical, children } = props;
  const position = `${vertical} ${horizontal}`;

  return <div className={`snackbar-component ${position}`}>{children}</div>;
};

export default SnackBar;
